import type { EventTariffResponse, UpsertEventTariffRequest } from '@jq4race/shared';

import { request } from './client.js';

// Admin API client for event-specific tariff overrides (event-tariff-override).
// Mirrors tariffs.ts (location tariffs) — same request/response shape, minus
// nightly mode and guest/nonGuest fields. Meaningful only for `per_attendee`
// events; the backend 404s for unknown/cross-org events and 422s with
// `charge_mode_mismatch` on upsert for non-per_attendee events.

export async function getEventTariff(eventId: string): Promise<EventTariffResponse> {
  return request<EventTariffResponse>(`/admin/events/${encodeURIComponent(eventId)}/tariff`, {
    method: 'GET',
  });
}

export async function upsertEventTariff(
  eventId: string,
  input: UpsertEventTariffRequest,
): Promise<EventTariffResponse> {
  return request<EventTariffResponse>(`/admin/events/${encodeURIComponent(eventId)}/tariff`, {
    method: 'PUT',
    body: input,
  });
}
